import { render } from "./NumericDataInspectorView.vue?vue&type=template&id=7ed40c20"
import script from "./NumericDataInspectorView.vue?vue&type=script&lang=js"
export * from "./NumericDataInspectorView.vue?vue&type=script&lang=js"

import exportComponent from "/home/nucleares/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__